// extracted by css-extract-rspack-plugin
export default {"colorWarn":"rgba(223, 126, 12, 1)","colorWarningTextHover":"rgba(252, 242, 231, 1)","text":"warning-message__text___sGPn3","hover":"warning-message__hover___R8zBf"};